var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg48D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "heart",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56.49 55.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #c2c1c0;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-4 {\n        fill: #d7d7d8;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-8 {\n        fill: none;\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-11 {\n        fill: #e6e7e8;\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-8);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -5.58,
    y1: 24.04,
    x2: 10.33,
    y2: 24.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#15a4dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#17a4dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#21a5dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#31a6dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#48a9dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5cabdd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.51,
    y1: 28.26,
    x2: 17.86,
    y2: 28.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#69b5e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12abdf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3.13,
    y1: 32.24,
    x2: 17.68,
    y2: 22.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126ba8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2692d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 23.87,
    y1: 28.24,
    x2: 36.57,
    y2: 28.24,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 17.22,
    y1: 28.24,
    x2: 33.53,
    y2: 28.24,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 20.42,
    y1: 32.14,
    x2: 28.08,
    y2: 32.14,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 22.02,
    y1: 25.58,
    x2: 29.86,
    y2: 25.58,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 8.56,
    y1: 43.4,
    x2: 47.93,
    y2: 43.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 9.57,
    y1: 43.54,
    x2: 46.59,
    y2: 43.54,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 8.56,
    y1: -472.01,
    x2: 47.93,
    y2: -472.01,
    gradientTransform: "translate(0 -459.71) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 9.57,
    y1: -471.87,
    x2: 46.59,
    y2: -471.87,
    gradientTransform: "translate(0 -459.71) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_48D",
    "data-name": "48D"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "6.9 26.81 8.92 19.69 5.65 21.78 3.92 28.24 9.89 28.4 10.28 25.96 10.03 26.85 6.9 26.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17.59 19.89 14.29 22.08 10.87 34.24 13.24 36.73 17.8 19.79 17.59 19.89"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M6.47,19.59s-2.87,.04-3.96,3.26L.51,30.59l8.48-.04-.35,1.26s-.87,4.11,2.43,5.01h2.14l.02-.09-2.37-2.49,3.42-12.16,3.29-2.19,.22-.09,.06-.21h-2.32s-3.11,.04-4.24,2.78l-1.01,3.59-.39,2.44-5.97-.16,1.73-6.46,3.27-2.1,.03-.1h-2.48Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M34.12,19.89h-10.25s2.1,1.47,2.1,1.47h5.8s2.05-.1,1.73,1.43c-.33,1.53-.95,3.72-.95,3.72,0,0-.42,1.1-.85,1.3,0,0,.29,.95,.23,1.63-.07,.68-1.17,3.95-1.17,3.95,0,0-.75,1.9-2.23,3.2h1.16s2.91,.3,3.87-2.96l1.22-3.78s.48-1.33,0-2.04c0,0,.7-.66,1-1.88l.78-2.91s.35-3.26-2.43-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M31.77,21.36h-5.8l-2.1-1.47h-.01s-2.65-.08-3.83,3.26l-.91,3.22s-.43,1.36,.3,1.44c0,0-.91,.47-1.3,2.34l-.74,3s-1.09,2.96,2.48,3.43h8.67c1.48-1.3,2.23-3.2,2.23-3.2,0,0,1.11-3.26,1.17-3.95,.07-.68-.23-1.63-.23-1.63,.42-.2,.85-1.3,.85-1.3,0,0,.62-2.18,.95-3.72,.33-1.53-1.73-1.43-1.73-1.43Zm-3.7,11.4h-4.91l.88-3.18h4.81l-.78,3.18Zm1.78-6.65h-4.91l.83-3h4.73l-.64,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.51,34.6s-2.32-.03-3.78,0c-1.47,.03-1.3-1.21-1.3-1.21l.39-1.86,3.2-1.85-.85,3.08h4.91l-2.57,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M27.34,28.01s-2.28,.1-3.68,0c-1.4-.1-1.63-.88-1.63-.88,0,0,.03-1.27,.26-1.92s3.49-2.1,3.49-2.1l-.83,3h4.91l-2.52,1.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M53.34,19.89h-14.11l1.76,1.79h10.52s2.3-.35,1.65,1.83l-2.48,9.26s-.36,2.51-3.7,3.83h.92c4.39,.49,5.35-3.01,5.35-3.01l2.74-10v-2.35c.04-1.57-2.65-1.35-2.65-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.51,21.67h-10.52l-1.76-1.79h-.28l-1.09,3.7h1.48l-3.35,13.01h11c3.35-1.32,3.7-3.83,3.7-3.83l2.48-9.26c.68-2.08-1.65-1.83-1.65-1.83Zm-3.7,11.39h-4.96l2.87-9.57h4.52l-2.43,9.57Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "45.34 23.67 42.86 33.07 47.82 33.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "45.73 23.5 41.51 25.33 39.51 34.28 45.38 34.28 47.82 33.07 42.86 33.07 45.73 23.5"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M28.62,48.72c-8,0-15.03-4.13-19.05-10.36-.65-.8-.99-1.32-1-1.32,3.52,7.51,11.17,12.71,20.05,12.71s15.63-4.28,19.32-11.3c-.42,.55-.87,1.08-1.34,1.57-4.06,5.46-10.48,8.69-17.97,8.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M28.62,48.72c7.49,0,13.91-3.23,17.97-8.69-4.37,4.62-10.77,6.88-17.98,7.36-10.07,.67-16.66-6.09-19.04-9.03,4.02,6.23,11.05,10.36,19.05,10.36Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M28.62,6.98c-8,0-15.03,4.13-19.05,10.36-.65,.8-.99,1.32-1,1.32,3.52-7.51,11.17-12.71,20.05-12.71s15.63,4.28,19.32,11.3c-.42-.55-.87-1.08-1.34-1.57-4.06-5.46-10.48-8.69-17.97-8.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M28.62,6.98c7.49,0,13.91,3.23,17.97,8.69-4.37-4.62-10.77-6.88-17.98-7.36-10.07-.67-16.66,6.09-19.04,9.03,4.02-6.23,11.05-10.36,19.05-10.36Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg48D);
export default __webpack_public_path__ + "static/media/48D.96d701580298af96fb6c64974569b376.svg";
export { ForwardRef as ReactComponent };